import { type DOMOutputSpec, type NodeSpec } from "prosemirror-model";

export const table: NodeSpec = {
	content: "table_row+",
	group: "block",
	tableRole: "table",
	isolating: true,
	parseDOM: [
		{
			tag: "div.pm-table-wrapper",
			contentElement: "table > tbody",
		},
		{ tag: "table" },
	],
	toDOM(): DOMOutputSpec {
		return [
			"div",
			{ class: "pm-table-wrapper" },
			["table", { class: "pm-table" }, ["tbody", 0]],
		];
	},
};
